export const captchaState = {
    imagen: '',
    codigo: '',
    isLoading: false,
}